import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs'
import { IAppPluginWidget, ModelService, PluginInjectorWidget } from 'core-client/api'
import { IExtendedAppPluginWidget } from '../../interfaces/extended-app-plugin-widget.interface'
import {
  IMapWidgetFormGroupSettings
} from '../../../map/map-widget-settings/map-widget-settings.interface'
import { INgsiMapBaseEntity } from '../../../map/lib/ngsild/interfaces/ngsi-entity.interface'
import * as leafletInstanceConfig from '../../../map/lib/ngsild/helpers/leaflet-instance-config.constants'
import { IMapWidget } from '../../interfaces/map-widget.interface'

@Injectable({
  providedIn: 'root'
})
export class WidgetSettingsObserveService {
  private _widgetSettingsSubject$: Subject<IAppPluginWidget> = new Subject<IAppPluginWidget>()
  private _widgetSettingsObservable$: Observable<IAppPluginWidget> = this._widgetSettingsSubject$.asObservable()

  private _defaultWidgetSettings: IMapWidgetFormGroupSettings = {
    widgetHeaderOption: 'alwaysDisplayed',
    showWidgetTitle: true,
    entities: [],
    dataSourceIdentifier: leafletInstanceConfig.config.dataSourceSelector.MMSI.label,
    dataSourceTypeCategory: 'AIS',
    baseTileLayer: 'OSM',
    latitude: 54.328808,
    longitude: 10.159384,
    zoom: 10,
    centerMapOnMarkers: false,
    enableAisTargets: false,
    enableAisPrediction: false,
    enableFusionMaritimeTarget: false,
    enableMaritimeTargets: false,
    enableRadarTarget: false,
    enablePlannedPath: false,
    enableRouteTracking: false,
    durationTime: null,
    maxTrackPoints: null,
    radius: null,
  }

  activeMapSettingObservable(mapWidget: IMapWidget, widget: PluginInjectorWidget.IWidget): void {
    widget.name = mapWidget.name
    widget.appPluginWidget.settings.showWidgetTitle = mapWidget.settings.showWidgetTitle;
    widget.appPluginWidget.settings.widgetHeader = mapWidget.settings.widgetHeader;
    this.emitWidgetSettings(mapWidget)
  }

  emitWidgetSettings(appPluginWidget: IMapWidget): void {
    this._widgetSettingsSubject$.next(appPluginWidget)
  }

  get observeWidgetSettings$(): Observable<IAppPluginWidget> {
    return this._widgetSettingsObservable$
  }

  get defaultWidgetSettings(): IMapWidgetFormGroupSettings {
    return this._defaultWidgetSettings
  }

  async updateWidgetSettingsBasedOnNotification(appPluginWidget: IExtendedAppPluginWidget, entity: INgsiMapBaseEntity, modelService: ModelService): Promise<void> {
    const data = JSON.parse(JSON.stringify(entity));
    if (data.location.type !== 'Point') {
      const lineStringCoords = data.location.coordinates as unknown as number[][]
      data.location.coordinates = lineStringCoords[0]
    }

    const updatedAppPluginWidget = {
      _id: appPluginWidget._id,
      enabled: appPluginWidget.enabled,
      name: appPluginWidget.name,
      app_plugin: appPluginWidget.app_plugin,
      layout: appPluginWidget.layout,
      settings: {
        widgetHeader: {
          alwaysDisplayed: appPluginWidget.settings.widgetHeader.alwaysDisplayed,
          onHoverDisplayed: appPluginWidget.settings.widgetHeader.onHoverDisplayed,
          alwaysOff: appPluginWidget.settings.widgetHeader.alwaysOff,
          transparent: appPluginWidget.settings.widgetHeader.transparent
        },
        showWidgetTitle: appPluginWidget.settings.showWidgetTitle,
        entities: appPluginWidget.settings.entities,
        dataSourceIdentifier: appPluginWidget.settings.dataSourceIdentifier,
        dataSourceTypeCategory: appPluginWidget.settings.dataSourceTypeCategory,
        baseTileLayer: appPluginWidget.settings.baseTileLayer,
        latitude: data.location.coordinates[1],
        longitude: data.location.coordinates[0],
        zoom: appPluginWidget.settings.zoom,
        centerMapOnMarkers: appPluginWidget.settings.centerMapOnMarkers,
        enableAisTargets: appPluginWidget.settings.enableAisTargets,
        enableAisPrediction: appPluginWidget.settings.enableAisPrediction,
        enableFusionMaritimeTarget: appPluginWidget.settings.enableFusionMaritimeTarget,
        enableMaritimeTargets: appPluginWidget.settings.enableMaritimeTargets,
        enableRadarTarget: appPluginWidget.settings.enableRadarTarget,
        enablePlannedPath: appPluginWidget.settings.enablePlannedPath,
        enableRouteTracking: appPluginWidget.settings.enableRouteTracking,
        durationTime: appPluginWidget.settings.durationTime,
        maxTrackPoints: appPluginWidget.settings.maxTrackPoints,
        radius: appPluginWidget.settings.radius
      }
    }
    await modelService._appPluginWidget.upsertOne(updatedAppPluginWidget)
  }
}
